import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../config';

const baseUrl = config.baseUrl;
const orgEndpoint = '/api/getOrg';
const updateOrgMerEndpoint = '/api/actualizarOrgMer';

const api = axios.create({
  baseURL: config.baseUrl,
});

api.interceptors.request.use(
  (config) => {
    const token = Cookies.get('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ============================
// GET organizaciones
// ============================
export const getOrganizaciones = async () => {
  try {
    const response = await api.get(`${baseUrl}${orgEndpoint}`);
    return {
      status: response.status,
      data: response.data.Organizaciones
    };
  } catch (error) {
    console.error('Error fetching organizations:', error);
    return {
      status: error.response?.status ?? 500,
      message: 'Error fetching organizations'
    };
  }
};

// ============================
// PUT actualizar org_mer
// ============================
export const updateOrgMer = async ({ oid, campo, valor, usuario }) => {
  try {
    const response = await api.put(`${baseUrl}${updateOrgMerEndpoint}`, {
      oid,
      campo,
      valor,
      usuario
    });

    return {
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error updating org_mer:', error);
    return {
      status: error.response?.status ?? 500,
      message: error.response?.data?.message ?? 'Error updating org_mer'
    };
  }
};
